export const placeInfo = [
  {
    id: 1,
    headerTitle: 'Lorem ipsum',
    headerSubTitle: 'soluta numquam',
    headerText:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Odit laboriosam cum recusandae quas? Natus, alias architecto error, sunt quae non placeat a eius minus maiores libero laborum perferendis, nobis qui?',
    title: 'Molestias officia excepturi',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates qui voluptate odio quod doloremque unde reprehenderit velit quaerat. Deserunt voluptatem natus suscipit aliquid, eligendi sequi dicta porro? Laudantium, libero est?',
    img: '.././images/garaj.jpg',
    maps:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1123.3850145412064!2d37.600589158335865!3d55.72774864513666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54b0be3ac9d11%3A0x735806d25b3bdc55!2z0JzRg9C30LXQuSDRgdC-0LLRgNC10LzQtdC90L3QvtCz0L4g0LjRgdC60YPRgdGB0YLQstCwIMKr0JPQsNGA0LDQtsK7!5e0!3m2!1sru!2sru!4v1547763408711'
  },
  {
    id: 2,
    headerTitle: 'Architecto commodi',
    headerSubTitle: 'commodi',
    headerText:
      'ipsum dolor sit, amet consectetur adipisicing elit. Dicta minus nulla nesciunt ex magni, fuga magnam accusantium sed nihil, eius similique? Dolores, ullam! Nisi magni, esse beatae ea suscipit asperiores!',
    title: 'Lorem unitye',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Est incidunt quo veritatis ad, nobis dolorum corrupti excepturi, natus fugit necessitatibus nihil nam minus explicabo debitis quod accusamus consectetur a eaque.',
    img: '.././images/mamm.jpg',
    maps:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1530.8494832689219!2d37.59693065124095!3d55.74157162835216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54baea59877dd%3A0xb4d0c3eb557a1c98!2zwqvQnNCe0KHQmtCe0JLQodCa0JjQmSDQlNCe0Jwg0KTQntCi0J7Qk9Cg0JDQpNCY0JjCuw!5e0!3m2!1sru!2sru!4v1547845790316'
  },
  {
    id: 3,
    headerTitle: 'Horund irute',
    headerSubTitle: 'injoyguru',
    headerText:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quis quas voluptatum quisquam nemo ratione neque aspernatur! Modi veniam distinctio velit quidem? Asperiores ut, atque odio porro debitis unde obcaecati esse!',
    title:
      'elit. Fugit, provident corrupti repudiandae nihil harum vel? Ducimus quos inventore suscipit sed laudantium eum quae, ex obcaecati quisquam? Pariatur omnis in reiciendis!',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium labore modi error sed ad quis obcaecati aliquid officia rerum alias quia voluptatum, consequatur at optio quas nisi autem necessitatibus nemo!',
    img: '.././images/pushkin.jpg',
    maps:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17967.866965087615!2d37.60335432286895!3d55.74141791432578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb9384e1a3b2da434!2z0JPQvtGB0YPQtNCw0YDRgdGC0LLQtdC90L3Ri9C5INC80YPQt9C10Lkg0JAu0KEuINCf0YPRiNC60LjQvdCw!5e0!3m2!1sru!2sru!4v1547878731704'
  },
  {
    id: 4,
    headerTitle: 'Perspiciatis illum',
    headerSubTitle: 'Voluptas similique',
    headerText: 'Dolor sit amet, consectetur adipisicing elit. Illo, iste',
    title: 'Perspiciatis illum',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda quibusdam nostrum dicta vitae, illo numquam autem excepturi rem unde eos exercitationem perferendis expedita, blanditiis eaque facilis explicabo aliquid doloribus rerum?',
    img: '.././images/tretyakovka.jpg',
    maps:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2245.9848620916428!2d37.618675215617316!3d55.741392000339864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54afe32078357%3A0xa50d6e8b9a7b028f!2z0JPQvtGB0YPQtNCw0YDRgdGC0LLQtdC90L3QsNGPINCi0YDQtdGC0YzRj9C60L7QstGB0LrQsNGPINCz0LDQu9C10YDQtdGP!5e0!3m2!1sru!2sru!4v1547878659681'
  },
  {
    id: 5,
    headerTitle: 'Earum fugiat',
    headerSubTitle: 'Fugiat',
    headerText: 'Illo mollitia',
    title: 'Consequuntur quo',
    description:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Assumenda illo numquam commodi nihil nam odit, minima perferendis delectus, quibusdam modi recusandae suscipit nobis cumque, veniam similique voluptas totam quasi mollitia.',
    img: '.././images/dom-fotografii.jpg',
    maps:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2245.9763498372804!2d37.59654121561725!3d55.741539900328505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54baea59877dd%3A0xb4d0c3eb557a1c98!2zwqvQnNCe0KHQmtCe0JLQodCa0JjQmSDQlNCe0Jwg0KTQntCi0J7Qk9Cg0JDQpNCY0JjCuw!5e0!3m2!1sru!2sru!4v1547878587877'
  },
  {
    id: 6,
    headerTitle: 'Deserunt consequatur',
    headerSubTitle: 'Excepturi sequi',
    headerText:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi a voluptatem nostrum dolore necessitatibus, nisi provident placeat officia rerum saepe laudantium quod sunt animi cum porro eligendi molestias, ut quisquam.',
    title: 'Animi nobis',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident, nostrum. Non, cupiditate facere quidem quibusdam atque aliquam corrupti minus esse dolor doloremque, vel aut. Quae eos quo consequuntur id commodi?',
    img: '.././images/mars.jpg',
    maps:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2244.397087990157!2d37.62463341561838!3d55.76897499821247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54a68e2e342b7%3A0x934bc1e9948c826b!2z0KbQtdC90YLRgCDQnNCw0YDRgQ!5e0!3m2!1sru!2sru!4v1547878491776'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'John',
    avatar: '.././avatars/avatar-1.png',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus, quaerat repellendus. Ad at sit laboriosam sint ea mollitia incidunt voluptatibus inventore libero dolorem velit dolor nobis odit tempora, ex consequuntur.'
  },
  {
    id: 2,
    name: 'Mike',
    avatar: '.././avatars/avatar-2.png',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus, quaerat repellendus. Ad at sit laboriosam sint ea mollitia incidunt voluptatibus inventore libero dolorem velit dolor nobis odit tempora, ex consequuntur.'
  },
  {
    id: 3,
    name: 'Sofia',
    avatar: '.././avatars/avatar-3.png',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus, quaerat repellendus. Ad at sit laboriosam sint ea mollitia incidunt voluptatibus inventore libero dolorem velit dolor nobis odit tempora, ex consequuntur.'
  },
  {
    id: 4,
    name: 'Joseph',
    avatar: '.././avatars/avatar-4.png',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus, quaerat repellendus. Ad at sit laboriosam sint ea mollitia incidunt voluptatibus inventore libero dolorem velit dolor nobis odit tempora, ex consequuntur.'
  },
  {
    id: 5,
    name: 'Natasha',
    avatar: '.././avatars/avatar-5.png',
    comment:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus, quaerat repellendus. Ad at sit laboriosam sint ea mollitia incidunt voluptatibus inventore libero dolorem velit dolor nobis odit tempora, ex consequuntur.'
  }
];

export const detailInfo = {
  // id: 1,
  // headerTitle: 'Lorem ipsum',
  // headerSubTitle: 'soluta numquam',
  // headerText:
  //   'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Odit laboriosam cum recusandae quas? Natus, alias architecto error, sunt quae non placeat a eius minus maiores libero laborum perferendis, nobis qui?',
  // title: 'Molestias officia excepturi',
  // description:
  //   'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates qui voluptate odio quod doloremque unde reprehenderit velit quaerat. Deserunt voluptatem natus suscipit aliquid, eligendi sequi dicta porro? Laudantium, libero est?',
  // img: '.././images/garaj.jpg',
  // maps:
  //   'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1123.3850145412064!2d37.600589158335865!3d55.72774864513666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54b0be3ac9d11%3A0x735806d25b3bdc55!2z0JzRg9C30LXQuSDRgdC-0LLRgNC10LzQtdC90L3QvtCz0L4g0LjRgdC60YPRgdGB0YLQstCwIMKr0JPQsNGA0LDQtsK7!5e0!3m2!1sru!2sru!4v1547763408711'
};

export const news = [
  {
    id: 1,
    newsTitle: 'Lorem ipsum',
    newsText:
    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates qui voluptate odio quod doloremque unde reprehenderit velit quaerat. Deserunt voluptatem natus suscipit aliquid, eligendi sequi dicta porro? Laudantium, libero est?',
  },
  {
    id: 2,
    newsTitle: 'Architecto commodi',
    newsText:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure maiores optio praesentium voluptate natus velit atque eaque eos quae perspiciatis. Perferendis reprehenderit aspernatur excepturi sint saepe quam laboriosam provident ducimus.'
  },
  {
    id: 3,
    newsTitle: 'Horund irute',
    newsText:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure maiores optio praesentium voluptate natus velit atque eaque eos quae perspiciatis. Perferendis reprehenderit aspernatur excepturi sint saepe quam laboriosam provident ducimus.'
  },
  {
    id: 4,
    newsTitle: 'Perspiciatis illum',
    newsText:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure maiores optio praesentium voluptate natus velit atque eaque eos quae perspiciatis. Perferendis reprehenderit aspernatur excepturi sint saepe quam laboriosam provident ducimus.'
  },
  {
    id: 5,
    newsTitle: 'Earum fugiat',
    newsText:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure maiores optio praesentium voluptate natus velit atque eaque eos quae perspiciatis. Perferendis reprehenderit aspernatur excepturi sint saepe quam laboriosam provident ducimus.'
  },
  {
    id: 6,
    newsTitle: 'Deserunt consequatur',
    newsText:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure maiores optio praesentium voluptate natus velit atque eaque eos quae perspiciatis. Perferendis reprehenderit aspernatur excepturi sint saepe quam laboriosam provident ducimus.'
  }
];
